/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AnswerInterviewSimulationQuestionRequestDto } from '../models';
// @ts-ignore
import type { CreateInterviewSimulationResponseDto } from '../models';
// @ts-ignore
import type { GetInterviewSimulationDetailsResponseDto } from '../models';
// @ts-ignore
import type { GetInterviewSimulationStatusResponseDto } from '../models';
// @ts-ignore
import type { GetInterviewSimulationsResponseDto } from '../models';
/**
 * InterviewSimulationsRestApi - axios parameter creator
 */
export const InterviewSimulationsRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Answer a question of an interview simulation
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {number} interviewSimulationId 
         * @param {number} questionId 
         * @param {AnswerInterviewSimulationQuestionRequestDto} answerInterviewSimulationQuestionRequestDto Question answer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerInterviewSimulationQuestion: async (processId: string, candidateId: string, interviewSimulationId: number, questionId: number, answerInterviewSimulationQuestionRequestDto: AnswerInterviewSimulationQuestionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('answerInterviewSimulationQuestion', 'processId', processId)
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('answerInterviewSimulationQuestion', 'candidateId', candidateId)
            // verify required parameter 'interviewSimulationId' is not null or undefined
            assertParamExists('answerInterviewSimulationQuestion', 'interviewSimulationId', interviewSimulationId)
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('answerInterviewSimulationQuestion', 'questionId', questionId)
            // verify required parameter 'answerInterviewSimulationQuestionRequestDto' is not null or undefined
            assertParamExists('answerInterviewSimulationQuestion', 'answerInterviewSimulationQuestionRequestDto', answerInterviewSimulationQuestionRequestDto)
            const localVarPath = `/api/v1/processes/{processId}/candidates/{candidateId}/inteview-simulations/{interviewSimulationId}/questions/{questionId}`
                .replace(`{${"processId"}}`, encodeURIComponent(String(processId)))
                .replace(`{${"candidateId"}}`, encodeURIComponent(String(candidateId)))
                .replace(`{${"interviewSimulationId"}}`, encodeURIComponent(String(interviewSimulationId)))
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(answerInterviewSimulationQuestionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new interview simulation
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInterviewSimulation: async (processId: string, candidateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('createInterviewSimulation', 'processId', processId)
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('createInterviewSimulation', 'candidateId', candidateId)
            const localVarPath = `/api/v1/processes/{processId}/candidates/{candidateId}/inteview-simulations`
                .replace(`{${"processId"}}`, encodeURIComponent(String(processId)))
                .replace(`{${"candidateId"}}`, encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get details of a interview simulation
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {number} interviewSimulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterviewSimulationDetails: async (processId: string, candidateId: string, interviewSimulationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getInterviewSimulationDetails', 'processId', processId)
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('getInterviewSimulationDetails', 'candidateId', candidateId)
            // verify required parameter 'interviewSimulationId' is not null or undefined
            assertParamExists('getInterviewSimulationDetails', 'interviewSimulationId', interviewSimulationId)
            const localVarPath = `/api/v1/processes/{processId}/candidates/{candidateId}/inteview-simulations/{interviewSimulationId}`
                .replace(`{${"processId"}}`, encodeURIComponent(String(processId)))
                .replace(`{${"candidateId"}}`, encodeURIComponent(String(candidateId)))
                .replace(`{${"interviewSimulationId"}}`, encodeURIComponent(String(interviewSimulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get status of a interview simulation
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {number} interviewSimulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterviewSimulationStatus: async (processId: string, candidateId: string, interviewSimulationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getInterviewSimulationStatus', 'processId', processId)
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('getInterviewSimulationStatus', 'candidateId', candidateId)
            // verify required parameter 'interviewSimulationId' is not null or undefined
            assertParamExists('getInterviewSimulationStatus', 'interviewSimulationId', interviewSimulationId)
            const localVarPath = `/api/v1/processes/{processId}/candidates/{candidateId}/inteview-simulations/{interviewSimulationId}/status`
                .replace(`{${"processId"}}`, encodeURIComponent(String(processId)))
                .replace(`{${"candidateId"}}`, encodeURIComponent(String(candidateId)))
                .replace(`{${"interviewSimulationId"}}`, encodeURIComponent(String(interviewSimulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of interview simulations
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterviewSimulations: async (processId: string, candidateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getInterviewSimulations', 'processId', processId)
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('getInterviewSimulations', 'candidateId', candidateId)
            const localVarPath = `/api/v1/processes/{processId}/candidates/{candidateId}/inteview-simulations`
                .replace(`{${"processId"}}`, encodeURIComponent(String(processId)))
                .replace(`{${"candidateId"}}`, encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InterviewSimulationsRestApi - functional programming interface
 */
export const InterviewSimulationsRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InterviewSimulationsRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Answer a question of an interview simulation
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {number} interviewSimulationId 
         * @param {number} questionId 
         * @param {AnswerInterviewSimulationQuestionRequestDto} answerInterviewSimulationQuestionRequestDto Question answer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async answerInterviewSimulationQuestion(processId: string, candidateId: string, interviewSimulationId: number, questionId: number, answerInterviewSimulationQuestionRequestDto: AnswerInterviewSimulationQuestionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.answerInterviewSimulationQuestion(processId, candidateId, interviewSimulationId, questionId, answerInterviewSimulationQuestionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewSimulationsRestApi.answerInterviewSimulationQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new interview simulation
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInterviewSimulation(processId: string, candidateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateInterviewSimulationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInterviewSimulation(processId, candidateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewSimulationsRestApi.createInterviewSimulation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get details of a interview simulation
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {number} interviewSimulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInterviewSimulationDetails(processId: string, candidateId: string, interviewSimulationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInterviewSimulationDetailsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInterviewSimulationDetails(processId, candidateId, interviewSimulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewSimulationsRestApi.getInterviewSimulationDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get status of a interview simulation
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {number} interviewSimulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInterviewSimulationStatus(processId: string, candidateId: string, interviewSimulationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInterviewSimulationStatusResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInterviewSimulationStatus(processId, candidateId, interviewSimulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewSimulationsRestApi.getInterviewSimulationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a list of interview simulations
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInterviewSimulations(processId: string, candidateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInterviewSimulationsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInterviewSimulations(processId, candidateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewSimulationsRestApi.getInterviewSimulations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InterviewSimulationsRestApi - factory interface
 */
export const InterviewSimulationsRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InterviewSimulationsRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Answer a question of an interview simulation
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {number} interviewSimulationId 
         * @param {number} questionId 
         * @param {AnswerInterviewSimulationQuestionRequestDto} answerInterviewSimulationQuestionRequestDto Question answer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerInterviewSimulationQuestion(processId: string, candidateId: string, interviewSimulationId: number, questionId: number, answerInterviewSimulationQuestionRequestDto: AnswerInterviewSimulationQuestionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.answerInterviewSimulationQuestion(processId, candidateId, interviewSimulationId, questionId, answerInterviewSimulationQuestionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new interview simulation
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInterviewSimulation(processId: string, candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<CreateInterviewSimulationResponseDto> {
            return localVarFp.createInterviewSimulation(processId, candidateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get details of a interview simulation
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {number} interviewSimulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterviewSimulationDetails(processId: string, candidateId: string, interviewSimulationId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetInterviewSimulationDetailsResponseDto> {
            return localVarFp.getInterviewSimulationDetails(processId, candidateId, interviewSimulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get status of a interview simulation
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {number} interviewSimulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterviewSimulationStatus(processId: string, candidateId: string, interviewSimulationId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetInterviewSimulationStatusResponseDto> {
            return localVarFp.getInterviewSimulationStatus(processId, candidateId, interviewSimulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of interview simulations
         * @param {string} processId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInterviewSimulations(processId: string, candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetInterviewSimulationsResponseDto> {
            return localVarFp.getInterviewSimulations(processId, candidateId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InterviewSimulationsRestApi - interface
 */
export interface InterviewSimulationsRestApiInterface {
    /**
     * 
     * @summary Answer a question of an interview simulation
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {number} interviewSimulationId 
     * @param {number} questionId 
     * @param {AnswerInterviewSimulationQuestionRequestDto} answerInterviewSimulationQuestionRequestDto Question answer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    answerInterviewSimulationQuestion(processId: string, candidateId: string, interviewSimulationId: number, questionId: number, answerInterviewSimulationQuestionRequestDto: AnswerInterviewSimulationQuestionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Create a new interview simulation
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createInterviewSimulation(processId: string, candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<CreateInterviewSimulationResponseDto>;

    /**
     * 
     * @summary Get details of a interview simulation
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {number} interviewSimulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInterviewSimulationDetails(processId: string, candidateId: string, interviewSimulationId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetInterviewSimulationDetailsResponseDto>;

    /**
     * 
     * @summary Get status of a interview simulation
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {number} interviewSimulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInterviewSimulationStatus(processId: string, candidateId: string, interviewSimulationId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetInterviewSimulationStatusResponseDto>;

    /**
     * 
     * @summary Get a list of interview simulations
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInterviewSimulations(processId: string, candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetInterviewSimulationsResponseDto>;

}

/**
 * InterviewSimulationsRestApi - object-oriented interface
 */
export class InterviewSimulationsRestApi extends BaseAPI implements InterviewSimulationsRestApiInterface {
    /**
     * 
     * @summary Answer a question of an interview simulation
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {number} interviewSimulationId 
     * @param {number} questionId 
     * @param {AnswerInterviewSimulationQuestionRequestDto} answerInterviewSimulationQuestionRequestDto Question answer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public answerInterviewSimulationQuestion(processId: string, candidateId: string, interviewSimulationId: number, questionId: number, answerInterviewSimulationQuestionRequestDto: AnswerInterviewSimulationQuestionRequestDto, options?: RawAxiosRequestConfig) {
        return InterviewSimulationsRestApiFp(this.configuration).answerInterviewSimulationQuestion(processId, candidateId, interviewSimulationId, questionId, answerInterviewSimulationQuestionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new interview simulation
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createInterviewSimulation(processId: string, candidateId: string, options?: RawAxiosRequestConfig) {
        return InterviewSimulationsRestApiFp(this.configuration).createInterviewSimulation(processId, candidateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get details of a interview simulation
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {number} interviewSimulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getInterviewSimulationDetails(processId: string, candidateId: string, interviewSimulationId: number, options?: RawAxiosRequestConfig) {
        return InterviewSimulationsRestApiFp(this.configuration).getInterviewSimulationDetails(processId, candidateId, interviewSimulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get status of a interview simulation
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {number} interviewSimulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getInterviewSimulationStatus(processId: string, candidateId: string, interviewSimulationId: number, options?: RawAxiosRequestConfig) {
        return InterviewSimulationsRestApiFp(this.configuration).getInterviewSimulationStatus(processId, candidateId, interviewSimulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of interview simulations
     * @param {string} processId 
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getInterviewSimulations(processId: string, candidateId: string, options?: RawAxiosRequestConfig) {
        return InterviewSimulationsRestApiFp(this.configuration).getInterviewSimulations(processId, candidateId, options).then((request) => request(this.axios, this.basePath));
    }
}

